var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceActionsDelete = function SvgInterfaceActionsDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2 9 3H4v2h1v15c0 .522.191 1.055.568 1.432S6.478 22 7 22h10c.522 0 1.055-.191 1.432-.568S19 20.522 19 20V5h1V3h-5l-1-1zM7 5h10v15H7zm2 2v11h2V7zm4 0v11h2V7z"
  })));
};
export default SvgInterfaceActionsDelete;